import { render, staticRenderFns } from "./JigActionModals.vue?vue&type=template&id=549c460c"
import script from "./JigActionModals.vue?vue&type=script&lang=ts"
export * from "./JigActionModals.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports